import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { IdentityProvider } from "@workspace/identity-react";
import "./styles/global.css";

/* global document, Office, module, require, HTMLElement */

const title = "Contoso Task Pane Add-in";

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
Office.onReady(() => {
  root?.render(
    <FluentProvider theme={webLightTheme}>
      <IdentityProvider 
        authority="https://preprodidentity.accessacloud.com"
        clientId="access.addins.mailmanagement.dev"
        redirectUri={window.location.origin + "/taskpane.html"}
        scope="openid email profile policy"
        signinFlow="interactive"
        workspaceUrl="https://preprodworkspace.accessacloud.com"
      >
        <App title={title} />
      </IdentityProvider>
    </FluentProvider>
  );
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(NextApp);
  });
}